(function () {
  var bound = false;
  var syncingQty = false;
  var subscribeDefaultApplied = false;

  // NEW: hide the purchase widget until Subscribe and Save is selected (no one-time flash).
  // CSS fallback shows it after 2.5s no matter what, so it can never stay hidden.
  (function hideWidgetUntilReady() {
    var style = document.createElement('style');
    style.textContent =
      'html.pdp-sub-pending .shopify_subscriptions_app_container{visibility:hidden;animation:pdpSubReveal 0s 2.5s forwards}' +
      '@keyframes pdpSubReveal{to{visibility:visible}}';
    (document.head || document.documentElement).appendChild(style);
    document.documentElement.classList.add('pdp-sub-pending');
  })();

  function revealWidget() {
    document.documentElement.classList.remove('pdp-sub-pending');
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function qtyInput() {
    return document.querySelector('.product-info-top input.quantity__input') || document.querySelector('input.quantity__input');
  }

  function getQty() {
    var input = qtyInput();
    return input ? parseInt(input.value, 10) || 1 : 1;
  }

  function setQty(value) {
    var input = qtyInput();
    if (!input) return;
    var next = String(value);
    if (input.value === next) return;
    syncingQty = true;
    input.value = next;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    syncingQty = false;
  }

  function selectOffer(qty) {
    document.querySelectorAll('[data-pdp-offer]').forEach(function (card) {
      var match = parseInt(card.getAttribute('data-qty'), 10) === qty;
      card.setAttribute('data-selected', match ? 'true' : 'false');
    });
    updateOneTimeUnitPrice();
  }

  function oneTimePriceEl() {
    var radio = document.querySelector('.shopify_subscriptions_app_container input[data-radio-type="one_time_purchase"]');
    var group = radio && radio.closest('.subscription_group');
    return group ? group.querySelector('.in_widget_price') : null;
  }

  function cleanPriceText(text) {
    return (text || '').replace(/\s*USD\s*/i, '').replace(/\s*\/?each\s*/gi, '').trim();
  }

  function rememberOriginalPrice(el) {
    if (!el || el.getAttribute('data-pdp-base-price')) return;
    var text = cleanPriceText(el.textContent);
    if (text) el.setAttribute('data-pdp-base-price', text);
  }

  function formatMoneyLike(sample, cents) {
    var value = (Math.round(cents) / 100).toFixed(2);
    if (!sample) return '$' + value;
    return sample.replace(/[\d,]+(?:\.\d+)?/, value);
  }

  function selectedOfferCard() {
    return document.querySelector('[data-pdp-offer][data-selected="true"]');
  }

  function ensurePriceObserver(el) {
    if (!el || el._pdpPriceObs) return;
    el._pdpPriceObs = new MutationObserver(function () {
      updateOneTimeUnitPrice();
    });
    el._pdpPriceObs.observe(el, { childList: true, characterData: true, subtree: true });
  }

  function updateOneTimeUnitPrice() {
    var el = oneTimePriceEl();
    if (!el) return;
    rememberOriginalPrice(el);
    ensurePriceObserver(el);

    var next = el.getAttribute('data-pdp-base-price');
    var card = isOneTimeSelected() ? selectedOfferCard() : null;
    if (card) {
      var total = parseInt(card.getAttribute('data-price-cents'), 10);
      var qty = parseInt(card.getAttribute('data-qty'), 10);
      if (total > 0 && qty > 0) {
        next = formatMoneyLike(el.getAttribute('data-pdp-base-price') || el.textContent, total / qty);
      }
    }
    if (!next) return;
    if (cleanPriceText(el.textContent) === next) return;
    el.textContent = next;
  }

  function isOneTimeSelected() {
    var oneTime = document.querySelector('.shopify_subscriptions_app_container input[data-radio-type="one_time_purchase"]');
    return !!(oneTime && oneTime.checked);
  }

  function syncOffersFromQty() {
    if (!isOneTimeSelected()) {
      selectOffer(0);
      return;
    }
    var value = getQty();
    if (value < 3) {
      selectOffer(0);
      return;
    }
    var match = document.querySelector('[data-pdp-offer][data-qty="' + value + '"]');
    if (match) selectOffer(value);
    else selectOffer(0);
  }

  function isFrequencyControl(target) {
    return !!(target && target.closest && (target.closest('select') || target.closest('.group_dropdown')));
  }

  function isSubscribeGroup(el) {
    return !!(el && el.querySelector && el.querySelector('input[data-radio-type="selling_plan_group"]'));
  }

  function resetSubscribePurchase() {
    selectOffer(0);
    setQty(1);
  }

  // NEW: pre-select Subscribe and Save once, as soon as the widget appears
  function applySubscribeDefault() {
    if (subscribeDefaultApplied) return;
    var subRadio = document.querySelector('.shopify_subscriptions_app_container input[data-radio-type="selling_plan_group"]');
    if (!subRadio) return; // widget not loaded yet, observer will retry
    subscribeDefaultApplied = true;
    if (!subRadio.checked) subRadio.click();
    wrapOneTime();
    cleanPrices();
    updateOneTimeUnitPrice();
    revealWidget();
  }

  // NEW: watch the page and apply the default the instant the widget is added
  function watchForWidget() {
    applySubscribeDefault();
    if (subscribeDefaultApplied) return;
    var obs = new MutationObserver(function () {
      applySubscribeDefault();
      if (subscribeDefaultApplied) obs.disconnect();
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () {
      obs.disconnect();
      revealWidget(); // safety: always show the widget after 3s
    }, 3000);
  }

  function wrapOneTime() {
    var radio = document.querySelector('.shopify_subscriptions_app_container input[data-radio-type="one_time_purchase"]');
    var group = radio && radio.closest('.subscription_group');
    var buyMore = document.querySelector('[data-pdp-buy-more]');
    if (!group) return false;

    var wrap = group.closest('.onetime-purchase-box');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'onetime-purchase-box';
      group.parentNode.insertBefore(wrap, group);
      wrap.appendChild(group);
    }
    if (buyMore && !wrap.contains(buyMore)) wrap.appendChild(buyMore);

    var dropdown = document.querySelector('.shopify_subscriptions_app_container .group_dropdown');
    if (dropdown) {
      var subGroup = dropdown.closest('.subscription_group');
      if (subGroup) subGroup.classList.add('has-dropdown-option');
    }
    return true;
  }

  function cleanPrices() {
    var container = document.querySelector('.shopify_subscriptions_app_container');
    if (!container) return;
    container.querySelectorAll('.in_widget_price').forEach(function (el) {
      var cleaned = (el.textContent || '').replace(/\s*USD\s*/i, '').replace(/\s*\/?each\s*/gi, '').trim();
      if (cleaned && (el.textContent || '').trim() !== cleaned) el.textContent = cleaned;
    });
  }

  function bind() {
    if (bound) return;
    bound = true;

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var card = target.closest('[data-pdp-offer]');
      if (card) {
        var qty = parseInt(card.getAttribute('data-qty'), 10);
        if (!qty) return;
        selectOffer(qty);
        setQty(qty);
        var oneTime = document.querySelector('.shopify_subscriptions_app_container input[data-radio-type="one_time_purchase"]');
        if (oneTime && !oneTime.checked) oneTime.click();
        return;
      }

      if (isFrequencyControl(target)) return;
      var subGroup = target.closest('.subscription_group');
      if (!isSubscribeGroup(subGroup)) return;
      resetSubscribePurchase();
    }, true);

    document.addEventListener('change', function (event) {
      if (!event.target) return;
      if (event.target.matches && event.target.matches('input[data-radio-type]')) {
        if (event.target.getAttribute('data-radio-type') === 'selling_plan_group') {
          resetSubscribePurchase();
        } else {
          syncOffersFromQty();
        }
        return;
      }
      if (!event.target.classList.contains('quantity__input')) return;
      if (syncingQty) return;
      syncOffersFromQty();
    });
  }

  function layout() {
    applySubscribeDefault(); // NEW
    wrapOneTime();
    cleanPrices();
    syncOffersFromQty();
    updateOneTimeUnitPrice();
  }

  bind();           // NEW: attach listeners immediately (safe before page load)
  watchForWidget(); // NEW: select Subscribe and Save as early as possible

  onReady(function () {
    bind();
    layout();

    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      layout();
      if (wrapOneTime() || tries >= 8) clearInterval(timer);
    }, 400);
  });
})();